import styled, { css } from 'styled-components';

export const StyledTextFieldWrapper = styled.div(
  ({ theme: { admanColors, spacers, colors } }) => css`
    width: 100%;

    label > span,
    label > span > span {
      font-family: InspireTWDC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400 !important;
      line-height: 18px;
      color: ${admanColors!.gray.light.fg1[1]};
      text-transform: none;
      letter-spacing: 0;
    }

    .TrekTextField-formControl {
      border-radius: 8px;
      font-family: InspireTWDC;
      color: ${admanColors!.gray.dark.fg[7]};
      padding: 0 ${spacers!.spacer02};
      background-color: ${colors!.colorWhite};
    }

    .TrekTextField-error {
      .TrekTextField-helpTextError {
        font-family: InspireTWDC;
        color: ${admanColors!.red.dark.fg[2]};
        font-size: 15px;
      }

      .TrekTextField-formControlError {
        border: 1px solid ${admanColors!.red.dark.fg[2]};
      }

      label > span,
      label > span > span {
        font-family: InspireTWDC;
        color: ${admanColors!.red.dark.fg[2]};
      }
    }

    input:active,
    input:focus {
      border: 1px solid ${admanColors!.gray.light.fg1[0]} !important;
      box-shadow: 0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.dark.bg1[0]};
    }

    input:hover {
      border: 1px solid ${admanColors!.gray.light.fg1[0]} !important;
    }

    input::placeholder {
      color: ${admanColors!.gray.light.fg1[2]};
    }
  `
);
